/* *******************************************************************
#
# Copyright 2019 Adobe
# All Rights Reserved.
#
# NOTICE: All information contained herein is, and remains
# the property of Adobe and its suppliers, if any. The intellectual
# and technical concepts contained herein are proprietary to Adobe
# and its suppliers and are protected by all applicable intellectual
# property laws, including trade secret and copyright laws.
# Dissemination of this information or reproduction of this material
# is strictly forbidden unless prior written permission is obtained
# from Adobe.
*********************************************************************/

import gql from 'graphql-tag';

export const COLLECTION_FRAGMENT = gql`
  fragment collectionAllFields on Collection {
    id
    title
    description
    tags
    blogSummary
    blogLink
    weight
    status
    imageUrl
    assets(
      page: $page
      limit: $limit
      sort: sameAsIds
      sortDir: asc
      filters: { status: [published, draft, archived] }
    ) {
      total
      hasMore
      items {
        id
        title
        status
        thumbnail {
          id
          url
        }
        attachments {
          id
          tags
          ... on PreviewAttachment {
            url
            kind
          }
        }
        extraData {
          key
          value
        }
      }
    }
    createdAt
    updatedAt
  }
`;

export const GET_COLLECTION = gql`
  query Collection($id: String!, $page: Int, $limit: Int = 100) {
    collection(id: $id) {
      ...collectionAllFields
    }
  }

  ${COLLECTION_FRAGMENT}
`;

export const DELETE_COLLECTION = gql`
  mutation DeleteCollection($id: String!) {
    deleteCollection(id: $id)
  }
`;

export const CREATE_UPDATE_COLLECTION = gql`
  mutation CreateOrUpdateCollection(
    $collection: CollectionInput!
    $id: String
    $page: Int = 0
    $limit: Int = 10
  ) {
    createOrUpdateCollection(collection: $collection, id: $id) {
      ...collectionAllFields
    }
  }

  ${COLLECTION_FRAGMENT}
`;
